<template>
  <div
    :class="[
      $style.date_editor,
      disabled && $style.disabled,
    ]"
  >
    <div
      v-show="!pickerPosition"
      :class="[
        $style.value,
        'date_value',
      ]"
      ref="value"
      @click="openEditor"
    >
      {{ formattedValue }}
    </div>
    <div
      v-if="pickerPosition"
      v-click-outside="onClickOutside"
    >
      <input
        id="date_editor"
        :class="$style.input"
        ref="input"
        type="text"
        :value="formattedValue"
        :style="{
          width: `${inputWidth}px`
        }"
        @keyup="onInputKeyUp"
      />
      <vgpDatePicker
        :class="$style.picker"
        :isShowTodayBtn="true"
        :value="value"
        :startOrEnd="columnName"
        :workDays="workDays"
        :minDate="minDate"
        :style="{
          top: `${pickerPosition.y}px`,
          left: `${pickerPosition.x}px`
        }"
        @onChange="onChangePicker"
        @click="onClickPicker"
      />
    </div>
  </div>
</template>

<script>
import vgpDatePicker from '$$vueCmp/datePicker/vgpDatePicker.vue';
import globalToast from '$$vueCmp/toast';
import moment from 'moment';

export default {
  name: 'DateEditor',
  components: {
    vgpDatePicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: new Date(),
    },
    columnName: {
      type: String,
      required: true,
    },
    workDays: {
      type: Array,
      required: false,
      default: [1, 2, 3, 4, 5],
    },
    minDate: {
      type: Object,
      required: false,
      default: undefined
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    'showCalendar',
    'onChange'
  ],
  data() {
    return {
      pickerPosition: null,
      inputWidth: 50,
      pendingValue: '',
      datePickerSizes: {
        width: 258,
        height: 310,
      },
    }
  },
  computed: {
    formattedValue() {
      return moment(this.value).format(user.dateFormat);
    }
  },
  methods: {
    openEditor() {
      if (this.disabled) return;

      this.calcPickerPosition();
      this.setInputWidth();

      this.$nextTick(() => {
        this.focusInput();
        this.pendingValue = this.formattedValue;
      });

      this.$emit('showCalendar', true);
    },
    closeEditor() {
      this.pendingValue = '';
      this.$emit('showCalendar', false);
      this.pickerPosition = null;
    },
    onClickOutside() {
      this.submit();
      this.closeEditor();
    },
    calcPickerPosition() {
      const inputRect = this.$refs.value.getBoundingClientRect();
      const boardContainerRect = this.$refs.value.closest('.board_main_container')?.getBoundingClientRect();
      let [x, y] = [inputRect.x, inputRect.y + inputRect.height];

      if (boardContainerRect && boardContainerRect.bottom < y + this.datePickerSizes.height) {
        y = inputRect.y - this.datePickerSizes.height;
      }

      if (boardContainerRect && boardContainerRect.right < x + this.datePickerSizes.width) {
        x = inputRect.right - this.datePickerSizes.width;
      }

      this.pickerPosition = { x, y };
    },
    setInputWidth() {
      if (this.$refs.value?.clientWidth) {
        this.inputWidth = this.$refs.value.clientWidth;
      }
    },
    focusInput() {
      this.$refs.input?.focus();
    },
    onChangePicker(newVal) {
      this.pendingValue = newVal;
      this.submit();
      this.closeEditor();
    },
    onClickPicker() {
      this.focusInput();
    },
    onInputKeyUp(e) {
      if (e.key === 'Escape') {
        this.closeEditor();
        return;
      }

      if (e.key === 'Enter') {
        this.submit();
        this.closeEditor();
        return;
      }

      this.pendingValue = e.target.value;
    },
    submit() {
      let newValue = null;

      if (typeof this.pendingValue === 'object') {
        newValue = this.pendingValue;
      } else {
        if (this.pendingValue.trim() === this.formattedValue) return;
        
        const newValueMoment = moment(this.pendingValue, user.dateFormat, true); 
        if (!newValueMoment.isValid()) {
          globalToast.warning(__('gantt_date_invalid'));

          return;
        }

        newValue = newValueMoment.toDate();
      }

      this.$emit('onChange', newValue);
    }
  }
}
</script>

<style module src="../less/dateEditor.less"></style>